<div class="google-signin">
    <button type="button" class="google-btn" (click)="signInWithGoogle()">
        <img src="https://developers.google.com/identity/images/g-logo.png" alt="" width="20" height="20" />
        <span>המשך באמצעות Google</span>
    </button>
</div>
